import React, { FunctionComponent, useEffect, useState } from 'react'
import styles from './ReserveDialog.module.sass'
import { Dialog } from '../../../../etc/Dialog/Dialog'
import { ID } from '../../../../../types/UtilityTypes'
import { useRootDispatch, useRootSelector } from '../../../../../utils/hooks'
import { projectsSelector } from '../../../../../utils/selectors'
import ProjectLine from '../../../projects/ProjectList/ProjectLine/ProjectLine'
import { Checkbox } from '../../../../controls/Checkbox/Checkbox'
import * as A from 'fp-ts/Array'
import { eqId, idToggle } from '../../../../../utils/entity-utils'
import { pipe } from 'fp-ts/function'
import { monoidSum } from 'fp-ts/Monoid'
import { projectActions } from '../../../../../redux/data/project/project-actions'
import OkCancel from '../../../../controls/OkCancel/OkCancel'
import StreamerIcon from 'files/archive/streamer.svg'
import { Classes, Colors } from '../../../../../styles'
import fileSize from 'filesize'
import { projectDeclination } from '../../../../../utils/utils'
import StreamerLoad from '../StreamerLoad/StreamerLoad'
import Spacer from '../../../../etc/Spacer'
import Skeleton from 'react-loading-skeleton'
import { RequestStatus } from '../../../../../responses/response'
import { Virtuoso } from 'react-virtuoso'

interface Props {
    onClose: () => void,
    onReserve: (ids: ID[]) => void,
}

const ReserveDialog: FunctionComponent<Props> = props => {
    const dispatch = useRootDispatch()
    const projects = useRootSelector(state => projectsSelector(state.pages.archive.reservable)(state))
    const info = useRootSelector(state => state.pages.archive.streamerInfo)
    const [excluded, setExcluded] = useState<ID[]>([])
    const status = useRootSelector(state => state.pages.archive.reserveStatus)

    const size = pipe(
        projects,
        A.filter(project => !A.elem(eqId)(project.id)(excluded)),
        A.foldMap(monoidSum)(project => project.size)
    )

    useEffect(() => {
        dispatch(projectActions.reservable.init())
    }, [dispatch])

    useEffect(() => {
        dispatch(projectActions.reservable.more(size))
    }, [dispatch, size])

    return <Dialog
        onClose={props.onClose}
        headerClassName={styles.header}
        actionsClassName={styles.actions}
        className={styles.body}
        contentClassName={styles.content}
        upheader={'При необходимости измените выбор'}
        header={<span>Перенести на стриммер № <span className={Classes.cPurpleMedium}>{info.number}</span></span>}
        subheader={<span>Максимальный объём <span className={Classes.cPurpleMedium}>{fileSize(info.max)}</span></span>}
        actions={({onClose}) => <>
            <div>
                <div className={Classes.f16b}>Будет перенесено: &nbsp;
                    <span className={Classes.cPurpleDark}>{projectDeclination(projects.length - excluded.length).toLowerCase()}</span>
                </div>
                <StreamerLoad size={size} min={info.min} max={info.max}/>
            </div>
            <Spacer/>
            <OkCancel
                onOk={() => props.onReserve([])}
                disabled={size > info.max || size < info.min}
                title={size > info.max?
                    'Размер слишком большой':
                    size < info.min?
                        'Размер слишком мал':
                        undefined
                }
                color={Colors.purpleMedium}
                icon={<StreamerIcon/>}
                onCancel={onClose}
            />
        </>}
    >
        {
            status === RequestStatus.FETCHING && <Skeleton height={90} count={6}/>
        }
        <Virtuoso
            totalCount={projects.length}
            itemContent={index => {
                const project = projects[index]
                return <ProjectLine
                    key={project.id}
                    minimal
                    projectId={project.id}
                    control={project => <Checkbox
                        value={!A.elem(eqId)(project.id, excluded)}
                        onChange={() => setExcluded(idToggle(project.id))}
                    />}
                >
                    <div className={Classes.cPurpleMedium}>{fileSize(project.size)}</div>
                </ProjectLine>
            }}
        />
    </Dialog>
}

export default ReserveDialog